import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75b451ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-container" }
const _hoisted_2 = { class: "select-month" }
const _hoisted_3 = { class: "report-body" }
const _hoisted_4 = { class: "report-list" }
const _hoisted_5 = {
  key: 0,
  class: "report-empty"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Não há relatório disponível para o mês selecionado!", -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TitleBar = _resolveComponent("TitleBar")!
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_MonthPicker = _resolveComponent("MonthPicker")!
  const _component_ReportCard = _resolveComponent("ReportCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TitleBar, { title: "Relatório " }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_PageHeader),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_MonthPicker, {
          onChangeMonth: _ctx.handleChangedMonth,
          value: _ctx.value
        }, null, 8, ["onChangeMonth", "value"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actualReports, (report) => {
            return (_openBlock(), _createBlock(_component_ReportCard, {
              key: report.id,
              report: report,
              tenant: _ctx.tenants.find(tenant => tenant.id == report.tenant)!
            }, null, 8, ["report", "tenant"]))
          }), 128))
        ]),
        (_ctx.actualReports.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}